import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    title: String,
    serviceOrderId: Number,
    serviceCost: Object,
    disabled: Boolean,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getSuppliers()

    if (this.serviceCost) {
      this.currentServiceCost = this.serviceCost
      this.supplierId = this.serviceCost.supplierId
      this.currentServiceCost.costType = Object.keys(this.costTypeMap).find(
        (key) => this.costTypeMap[key] === this.serviceCost.costType
      )
      this.currentServiceCost.costValue = this.serviceCost.costValue
      this.isEditing = true

      if (this.currentServiceCost.costType === 'Custo logístico') {
        this.useInternalTeam = !!this.serviceCost.isInternalTeam
        this.useSupplier = !this.useInternalTeam
      }
    }
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    isEditing: false,
    loading: false,
    supplierLoading: false,
    firstValid: false,
    error: false,
    dialog: false,
    institutionId: null,
    supplierId: null,
    suppliers: [],
    useInternalTeam: true,
    useSupplier: false,
    currentServiceCost: {
      id: 0,
      costValue: '',
      costType: null,
      invoiceNumber: '',
      description: '',
    },
    costTypes: ['Custo material', 'Custo serviços', 'Custo logístico'],
    costTypeMap: {
      'Custo material': 0,
      'Custo serviços': 1,
      'Custo evitado': 2,
      'Custo logístico': 3,
    },
    costValueRules: [(v) => !!v || 'Valor custo é requerido'],
    invoiceNumberRules: [
      (v) => !!v || 'Nª da nota é requerido',
      (v) => v.length <= 20 || 'Nº da nota deve ter no máximo 20 caracteres',
    ],
    costTypeRules: [(v) => v != -1 || 'Tipo do custo é requerido'],
    descriptionRules: [(v) => !!v || 'Descrição é requerida'],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.close()
      }
    },

    async getSuppliers() {
      this.supplierLoading = true

      await this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.suppliers = response.content
          this.supplierLoading = false
        })
    },

    selectInternalTeam(value) {
      this.useInternalTeam = value
      if (value) {
        this.useSupplier = false
        this.supplierId = null
      }
    },

    selectSupplierOption(value) {
      this.useSupplier = value
      if (value) {
        this.useInternalTeam = false
      }
    },

    async submit() {
      this.loading = true

      const isLogisticCost = this.currentServiceCost.costType === 'Custo logístico'

      const serviceOrderCost = {
        Id: this.currentServiceCost.id,
        CostValue: this.currentServiceCost.costValue,
        CostType: this.costTypeMap[this.currentServiceCost.costType],
        InvoiceNumber: this.currentServiceCost.invoiceNumber,
        SupplierId: isLogisticCost && this.useInternalTeam ? null : this.supplierId,
        Description: this.currentServiceCost.description,
        ServiceOrderId: this.serviceOrderId,
        IsInternalTeam: isLogisticCost ? this.useInternalTeam : false,
      }

      let url = 'serviceOrderCost/add'

      if (this.isEditing) {
        url = 'serviceOrderCost/edit'
      }

      await this.apiService
        .post(url, serviceOrderCost)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },
  },
}
